import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGmail = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 33,
	height: 24,
	viewBox: "0 0 33 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_5626_43845)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M2.68182 23.9998H7.77273V11.6362L0.5 6.18164V21.818C0.5 23.0253 1.47818 23.9998 2.68182 23.9998Z",
					fill: "#4285F4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.2273 23.9998H30.3182C31.5255 23.9998 32.5 23.0216 32.5 21.818V6.18164L25.2273 11.6362",
					fill: "#34A853"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.2273 2.18215V11.6367L32.5 6.18215V3.27306C32.5 0.574876 29.42 -0.963306 27.2637 0.654875",
					fill: "#FBBC04"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M7.77271 11.6362V2.18164L16.5 8.7271L25.2273 2.18164V11.6362L16.5 18.1816",
					fill: "#EA4335"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M0.5 3.27306V6.18215L7.77273 11.6367V2.18215L5.73636 0.654875C3.57636 -0.963306 0.5 0.574876 0.5 3.27306Z",
					fill: "#C5221F"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_5626_43845",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 32,
				height: 24,
				fill: "white",
				transform: "translate(0.5)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgGmail);
export { ForwardRef as ReactComponent };
